import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'or', name: 'Oromoo' },
    { code: 'am', name: 'አማሪኛ' }
  ];

  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const saved = localStorage.getItem('appLanguage');
    const defaultLang = saved || i18n.language || 'en';
    const langObj = languages.find(lang => lang.code === defaultLang);
    return langObj?.name || 'English';
  });

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language.code);
    setSelectedLanguage(language.name);
    setIsOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-1 focus:outline-none"
      >
        <FontAwesomeIcon
          icon={faGlobe}
          className="w-5 h-5 text-gray-700 hover:text-blue-500 transition-colors"
        />
        <span className="hidden sm:inline text-sm text-gray-700">
          {selectedLanguage}
        </span>
        <svg
          className={`w-4 h-4 text-gray-700 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50">
          <div className="py-1">
            {languages.map((language) => (
              <button
                key={language.code}
                onClick={() => handleLanguageChange(language)}
                className={`block w-full text-left px-4 py-2 text-sm ${selectedLanguage === language.name
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-700 hover:bg-gray-100'
                  }`}
              >
                {language.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;